import { DisplayGroupTypeEnum } from '../../../api/displayGroups/enums/display-group-type.enum';
import { DisplayGroupApiModel } from '../../../api/displayGroups/models/display-group.api.model';


export class DisplayGroupModel {
    id: number;
    name: string;
    type: DisplayGroupTypeEnum;
    collapsed: boolean;
    listItems: any[];

    constructor(apiModel?: DisplayGroupApiModel) {
        if (apiModel) {
            this.id = apiModel.id;
            this.name = apiModel.name;
            this.type = apiModel.type;
        }
        this.collapsed = false;
        this.listItems = [];
    }

    toApiModel(): DisplayGroupApiModel {
        return {
            id: this.id,
            name: this.name,
            type: this.type
        };
    }
}
